export default __webpack_public_path__ + "static/media/arrow.64064815.svg";